/*** IMPORTS FROM imports-loader ***/
(function() {

/*eslint-disable */
define(function(require) {
    var $ = require('jquery');
    var jqueryMobileFilterableNormalizingFilter = require('./jquery-mobile-filterable-normalizing-filter');

    $(document).one('mobileinit', function() {
        $.mobile.defaultPageTransition = 'slidefade';
        $.mobile.minScrollBack = 5;
        $.mobile.buttonMarkup.hoverDelay = 50;
        $.mobile.autoInitializePage = false;

        $.mobile.jqmRouter={
            firstMatchOnly: true
        };

        $.mobile.page.prototype.options.degradeInputs.date = true;
        $.mobile.datepickerOptions = {
            showOtherMonths: false,
            selectOtherMonths: false
        };

        // We use $.mobile.loading("show") in a pagebeforeshow event handler, so that we always
        // show the loading spinner until a page decides that it's finished doing whatever async
        // operations it has to do before the page is rendered.
        //
        // Unfortunately jquerymobile hides the loading indicator _after_ it triggers any
        // pagebeforeshow listeners. So the spinner is hidden before it's visible.
        //
        // Monkey-patch jquerymobile to disable this behaviour.
        //
        // $.mobile.hidePageLoadingMsg is called internally when pages are loaded with XHR and
        // added to the DOM. We are not (currently) doing this, so this monkey-patch seems
        // reasonably safe.
        $.mobile.hidePageLoadingMsg = function() {};

        $.mobile.filterable.prototype.options.filterCallback = jqueryMobileFilterableNormalizingFilter;
    });
});

}.call(window));